import * as React from "react";
import { isDefined, optionalKey } from "@grandvisionhq/utils";
import { getPriceSpecificationConfig } from "../../../../utils/utils/get-price-specification-config.js";
import { parseListingProductData } from "../../../../utils/utils/parse-listing-product-data.js";
import { createPriceSpecification } from "../../../actions/StructuredData/actions/helpers.js";
import { JsonLd } from "../../../StructuredData/JsonLd.js";
const ProductsSd = ({ items, links, originUrl }) => {
  const productList = items.filter(isDefined).map((product, index) => {
    const sku = product.masterVariant.sku;
    const activeVariant = product.masterVariant;
    const link = links.find((link2) => link2?.sku === sku)?.link;
    const productUrl = `${originUrl || ""}${link}`;
    const { name, description, brand, category } = parseListingProductData(product, activeVariant);
    const specification = isDefined(activeVariant.pricing.price) ? getPriceSpecificationConfig(activeVariant.pricing.price, product.includedVatAmount) : void 0;
    const offers = [
      {
        "@type": "Offer",
        priceSpecification: createPriceSpecification(specification, activeVariant.sku)
      }
    ];
    const aggregateRating = product.ratingsSummary ? {
      "@type": "AggregateRating",
      ratingValue: product.ratingsSummary.average,
      reviewCount: product.ratingsSummary.reviewCount
    } : {};
    const listItemContent = {
      "@type": "Product",
      "@id": `${productUrl}#product`,
      name: name && String(name) || sku,
      url: productUrl,
      ...optionalKey("description", description),
      ...optionalKey("brand", brand),
      ...optionalKey("category", category),
      ...optionalKey("offers", offers),
      ...optionalKey("aggregateRating", aggregateRating),
      sku
    };
    return {
      "@type": "ListItem",
      position: index + 1,
      item: listItemContent
    };
  });
  const payload = {
    "@type": "ItemList",
    itemListElement: productList
  };
  return /* @__PURE__ */ React.createElement(JsonLd, { ...payload });
};
export {
  ProductsSd
};
//# sourceMappingURL=Products.sd.js.map
